import React from 'react';
import { Camera, Rotate3d, Square, Sparkles, Move, Bot, Truck, Box } from 'lucide-react';

import { EVENT_TYPES } from '../landingPageData';
import css from './EventTypes.module.css';

const ICONS = { Camera, Rotate3d, Square, Sparkles, Move, Bot, Truck, Box };

const EventTypes = () => {
  return (
    <section className={css.section} id="event-types">
      <div className={css.container}>
        <div className={css.head}>
          <span className={css.overline}>Browse by service type</span>
          <h2 className={css.title}>Subcontract by booth & service type.</h2>
          <p className={css.sub}>
            Providers on WLE cover every booth format, so you can subcontract exactly the setup an
            event needs, with live availability and verified reviews.
          </p>
        </div>

        <div className={css.grid}>
          {EVENT_TYPES.map(({ icon, title, blurb }) => {
            const Icon = ICONS[icon];
            return (
              <div key={title} className={css.card}>
                <span className={css.cardIcon}>{Icon ? <Icon /> : null}</span>
                <h3 className={css.cardTitle}>{title}</h3>
                <p className={css.cardBlurb}>{blurb}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default EventTypes;
